import React from "react";
import { Mail, Phone, MapPin, MessageCircle, Clock } from "lucide-react";
import { BRAND } from "../data/content";

const Contact = () => {
  const wa = `https://wa.me/${BRAND.phoneDigits}?text=${encodeURIComponent(
    "Hi Gruham, I have a question"
  )}`;

  return (
    <div className="font-body">
      <section className="bg-[#FBF7F0] py-14 border-b border-[#F39C12]/15">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm uppercase tracking-[0.2em] text-[#D63031] font-semibold mb-3">
            Contact
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#2C3E50]">
            We're here for you.
          </h1>
          <p className="mt-4 text-[#2C3E50]/85 max-w-xl mx-auto">
            Reach us on WhatsApp, phone or email. We usually reply within a day.
          </p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <a
            data-testid="contact-whatsapp"
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white border border-[#F39C12]/20 rounded-2xl p-6 lift-on-hover block"
          >
            <div className="w-12 h-12 rounded-xl bg-[#25D366]/15 flex items-center justify-center mb-4">
              <MessageCircle className="w-6 h-6 text-[#25D366]" />
            </div>
            <p className="text-xs uppercase tracking-widest text-[#F39C12] font-semibold">
              WhatsApp — fastest
            </p>
            <p className="font-display font-semibold text-[#2C3E50] mt-1">
              {BRAND.phone}
            </p>
            <p className="text-sm text-[#7F8C8D] mt-1">
              Tap to chat now — Q&A, orders, returns.
            </p>
          </a>

          <a
            data-testid="contact-phone"
            href={`tel:${BRAND.phone}`}
            className="bg-white border border-[#F39C12]/20 rounded-2xl p-6 lift-on-hover block"
          >
            <div className="w-12 h-12 rounded-xl bg-[#FFF5E1] flex items-center justify-center mb-4">
              <Phone className="w-6 h-6 text-[#D63031]" />
            </div>
            <p className="text-xs uppercase tracking-widest text-[#F39C12] font-semibold">
              Call us
            </p>
            <p className="font-display font-semibold text-[#2C3E50] mt-1">
              {BRAND.phone}
            </p>
            <p className="text-sm text-[#7F8C8D] mt-1 inline-flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" /> {BRAND.hours}
            </p>
          </a>

          <a
            data-testid="contact-email"
            href={`mailto:${BRAND.email}`}
            className="bg-white border border-[#F39C12]/20 rounded-2xl p-6 lift-on-hover block"
          >
            <div className="w-12 h-12 rounded-xl bg-[#FFF5E1] flex items-center justify-center mb-4">
              <Mail className="w-6 h-6 text-[#D63031]" />
            </div>
            <p className="text-xs uppercase tracking-widest text-[#F39C12] font-semibold">
              Email
            </p>
            <p className="font-display font-semibold text-[#2C3E50] mt-1 break-all">
              {BRAND.email}
            </p>
            <p className="text-sm text-[#7F8C8D] mt-1">
              We reply within 24 business hours.
            </p>
          </a>

          <div className="bg-white border border-[#F39C12]/20 rounded-2xl p-6 sm:col-span-2 lg:col-span-3">
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[#D63031] mt-0.5 shrink-0" />
              <div>
                <p className="text-xs uppercase tracking-widest text-[#F39C12] font-semibold">
                  Registered address
                </p>
                <p className="text-[#2C3E50] mt-1">{BRAND.address}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
